import React, { useContext } from "react";
import CancelOfferingViewModel from "./viewModel";
import Card from "../../components/Card";
import Button from "../../components/Button";
import Processing from "../../components/Status/Processing";
import logo from '../../asset/logo.png'
import "./style.css";
import Failed from "../../components/Status/Failed";
import { Toast, ToastContainer } from "react-bootstrap";

const CancelOffering = () => {
  const {
    onConfirm,
    isLoading,
    error,
    alert,
    showAlert,
    onCloseAlert,
    address,
    isChainValid,
    requestAccounts,
  } = useContext(CancelOfferingViewModel.Context);
  return (
    <main id={"cancel-offering"} className={'wraps'}>
      <ToastContainer position="top-end" className="p-3">
        {showAlert && (
          <Toast onClose={() => onCloseAlert()} delay={5000} autohide>
            <Toast.Header>
              <strong className="me-auto">{alert.title}</strong>
            </Toast.Header>
            <Toast.Body>{alert.message}</Toast.Body>
          </Toast>
        )}
      </ToastContainer>
      <div className={'logo_imgs'}>
          <img src={logo} alt="QonBay.io"/>
      </div>
      <Card>
     
        <h2>Cancel Offering</h2>
        {!address && (
          <Button
            variant={"secondary"}
            onClick={() => requestAccounts()}
            disabled={!isChainValid}
            style={{ marginBottom: "1rem" }}
          >
            Connect Wallet
          </Button>
        )}
        {isLoading && <Processing />}
        {!isLoading && error && <Failed />}
        <Button
          onClick={() => onConfirm()}
          disabled={isLoading || !address || !isChainValid}
          className={"default-btn confirm-btn"}
        >
          {error ? "Retry" : "Confirm"}
        </Button>
      </Card>
    </main>
  );
};

export default CancelOfferingViewModel.withProvider(CancelOffering);
